import { useEffect, useState } from "react";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { CommonService } from "../services/CommonService";
import { ICostReviewPos } from "../common/interfaces";

const ESTADOS = {
  pending: "En revisión: no la vuelvas a capturar",
  approved: "Aprobada: ya se recibió",
  rejected: "Rechazada: no se recibió",
};

interface CostReviewsPosProps {
  warehouseId: string;
}

// Compras retenidas por costo: al aprobarse salen de la lista de ordenes, aqui se ve en que quedaron.
export const CostReviewsPos = ({ warehouseId }: CostReviewsPosProps) => {
  const [reviews, setReviews] = useState<ICostReviewPos[]>([]);

  useEffect(() => {
    CommonService.getCostReviewsPos(warehouseId).then((res) => {
      if (res.success) {
        setReviews(res.object ?? []);
      }
    });
  }, [warehouseId]);

  if (reviews.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: "30px", textAlign: "left" }}>
      <Typography variant="h6">Compras en revisión de costos</Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>OC</TableCell>
              <TableCell>Producto</TableCell>
              <TableCell align="right">Cantidad</TableCell>
              <TableCell align="right">Costo</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reviews.map((row) => (
              <TableRow key={row.review_id}>
                <TableCell>{row.po_id}</TableCell>
                <TableCell>{row.product_name}</TableCell>
                <TableCell align="right">{row.quantity}</TableCell>
                <TableCell align="right">${row.price.toFixed(2)}</TableCell>
                <TableCell>
                  {ESTADOS[row.status]}
                  {row.decision_note ? ` (${row.decision_note})` : ""}
                </TableCell>
                <TableCell>
                  {row.receipt_id && (
                    <Button
                      size="small"
                      onClick={() => CommonService.printTicketPOR(row.receipt_id as number)}
                    >
                      Imprimir nota
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
